import * as Sentry from "@sentry/react";

const isProduction = import.meta.env.VITE_APP_ENV === "production";
const isStaging = import.meta.env.VITE_APP_ENV === "staging";

export function initializeSentry() {
  if (isProduction || isStaging) {
    console.log(`🔍 [Sentry] Initializing Sentry for ${import.meta.env.VITE_APP_ENV} environment`);

    Sentry.init({
      dsn: "https://f554b615bb2966223a365399b9292cbc@o4510510380548096.ingest.de.sentry.io/4510510500347984",
      environment: import.meta.env.VITE_APP_ENV || "unknown",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],
      // Set tracesSampleRate based on environment
      // Production: 10% sampling to reduce overhead
      // Staging: 100% sampling for full visibility
      tracesSampleRate: isProduction ? 0.1 : 1.0,
      // Capture 10% of sessions for replay
      replaysSessionSampleRate: 0.1,
      // Capture 100% of sessions with errors for replay
      replaysOnErrorSampleRate: 1.0,
      beforeSend(event) {
        // Filter out sensitive data
        if (event.request?.cookies) {
          delete event.request.cookies;
        }
        // Remove sensitive headers
        if (event.request?.headers) {
          delete event.request.headers["authorization"];
          delete event.request.headers["cookie"];
        }
        return event;
      },
    });
  } else {
    console.log(
      `🔍 [Sentry] Skipping Sentry initialization in ${import.meta.env.VITE_APP_ENV || "development"} environment`,
    );
  }
}

export { Sentry };
